import React, { ReactNode } from 'react';
import { ThemeProvider as SherpaThemeProvider, boschLight } from '@bshgroup/component-themes';
import { BoschFonts } from '@bshgroup/component-fonts';
import NotificationProvider from './src/contexts/notification';
import { BoschAuthProvider } from './src/contexts/boschAuth';
import { ThemeProvider } from '@dssf/component-library';

export function wrapRootElement({ element }: { element: ReactNode }) {
  return (
    <ThemeProvider>
      <SherpaThemeProvider theme={boschLight}>
        <BoschAuthProvider>
          <NotificationProvider>
            <BoschFonts />
            {element}
          </NotificationProvider>
        </BoschAuthProvider>
      </SherpaThemeProvider>
    </ThemeProvider>
  );
}
